import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDerivatives = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M9.653 6.404a5.75 5.75 0 1 1 7.942 7.942.75.75 0 0 0 .81 1.264A7.25 7.25 0 1 0 8.39 5.596a.75.75 0 0 0 1.262.808ZM3.75 14.5a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0ZM9.5 7.25a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M9.225 11.917a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.031.575 1.69a.29.29 0 0 1-.441.332L9.5 16.16l-1.522 1.057a.29.29 0 0 1-.442-.332l.575-1.69-1.486-1.031a.29.29 0 0 1 .166-.53h1.85l.584-1.716Z"
    />
  </svg>
);
export default SvgTwoColorDerivatives;
